module.exports = __webpack_public_path__ + "static/media/hourglass-end.6ad6ce22.svg";